export interface CommerceErrorInterface {
  /**
   * @deprecated Errors often contain circular references and cannot be serialized. Only use this field if you require it.
   */
  error?: Error | unknown;
  message: string;
  stack?: string;
  code?: number;
}

export class CommerceError implements CommerceErrorInterface {
  constructor(
    public message: string,
    public stack?: string,
    public code?: number,
  ) {}
}
